import { render, staticRenderFns } from "./activityTypeDetail.vue?vue&type=template&id=5d388664&scoped=true&"
import script from "./activityTypeDetail.vue?vue&type=script&lang=js&"
export * from "./activityTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d388664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d388664')) {
      api.createRecord('5d388664', component.options)
    } else {
      api.reload('5d388664', component.options)
    }
    module.hot.accept("./activityTypeDetail.vue?vue&type=template&id=5d388664&scoped=true&", function () {
      api.rerender('5d388664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/activityManage/activityType/activityTypeDetail.vue"
export default component.exports